(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    event.target.querySelectorAll('[data-soldout-note]').forEach(function (note) {
      note.hidden = !!(variant && variant.available);
      var body = note.querySelector('[data-notify-body]');
      if (body && variant) {
        var name = body.getAttribute('data-notify-name');
        var label = variant.title && variant.title !== 'Default Title' ? ' · ' + variant.title : '';
        body.value = body.value.split(name)[0] + name + label;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-list"] && !Shopify.designMode) return;
  try {
    /* On a bundle with combos, the "inside this bundle" row follows the option picked above. */
  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    var groups = document.querySelectorAll('[data-bundle-variant]');
    if (!groups.length) return;
    groups.forEach(function (group) { group.hidden = group.getAttribute('data-bundle-variant') !== String(variant.id); });
  });

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) return;
        var list = this.closest('.product-list');
        if (list && list.querySelector('.product-list__grid, .product-list__rail')) return;
        var self = this;
        if (!('IntersectionObserver' in window)) { this.load(list); return; }
        /* Fetch only when the shopper scrolls within about a screen of the recommendations */
        this.observer = new IntersectionObserver(function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          self.observer.disconnect();
          self.load(list);
        }, { rootMargin: '0px 0px 800px 0px' });
        this.observer.observe(list || this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      load(list) {
        if (this.dataset.loaded) return;
        this.dataset.loaded = 'true';
        var self = this;
        fetch(this.dataset.url)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-block-id="' + self.dataset.blockId + '"]');
            var freshList = fresh && fresh.closest('.product-list');
            if (freshList && list && freshList.querySelector('.product-list__grid, .product-list__rail')) {
              list.innerHTML = freshList.innerHTML;
              if (window.AromaMotion) window.AromaMotion.init(list);
            } else if (list) {
              var wrapper = list.closest('[data-hide-when-empty]');
              if (wrapper) wrapper.hidden = true;
            }
          });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-video-toggle]');
    if (!toggle) return;
    var video = toggle.closest('.video-block').querySelector('video');
    if (!video) return;
    var playing = !video.paused;
    var wrapper = video.closest('[data-lazy-video]');
    if (wrapper) wrapper.dataset.userPaused = playing ? 'true' : '';
    if (playing) video.pause(); else video.play();
    toggle.setAttribute('aria-label', playing ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
    toggle.querySelector('.video-block__icon-pause').hidden = playing;
    toggle.querySelector('.video-block__icon-play').hidden = !playing;
  });
  } catch(e) { console.error(e); }
})();

})();
